import { AppointmentOption } from '@components/AppointmentTypePage/AppointmentTypePage.styles';
import {
  LuxModal,
  LuxModalFooter,
  LuxModalHeader,
  LuxRadioButton,
  LuxSelectablePill,
  LuxTypography,
  Stack,
  useMediaQuery,
  useTheme,
} from '@gemini/fe-ds-core';
import useCustomTranslation from '@hooks/useCustomTranslation';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { TabletBreakpoint } from '@utils/consts/breakpoints.consts';
import { useUrlsContext } from '@utils/contexts/UrlsContext';
import { AppointmentTypeResponse } from '@utils/interfaces';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

interface ServicesModalProps {
  isOpen: boolean;
  appointmentTypes: AppointmentTypeResponse;
  onClose: () => void;
}

export function ServicesModal({
  isOpen,
  appointmentTypes,
  onClose,
}: ServicesModalProps) {
  const theme = useTheme();
  const { t } = useCustomTranslation();
  const history = useHistory();
  const { Urls } = useUrlsContext();
  const setAppTypeIdFromUrl = useOnlineBookingStore(
    state => state.setAppTypeIdFromUrl,
  );
  const brandName = useOnlineBookingStore(state => state.brandName);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState<
    string | undefined
  >(undefined);
  const isMobile = useMediaQuery(`(max-width:${TabletBreakpoint}px)`);

  /*  useEffect(() => {
    if (appointmentTypes) {
      appointmentTypes.forEach(app => {
        console.log('Options for', app.title, ':', app.options);
      });
    }
  }, [appointmentTypes]); */

  useEffect(() => {
    console.log('appointmentTypes:', appointmentTypes);
  }, [appointmentTypes]);

  return (
    <LuxModal
      open={isOpen}
      header={
        <LuxModalHeader
          enableCloseIcon
          onClose={() => {
            onClose();
            setSelectedAppointmentId(undefined);
          }}
          title={
            <LuxTypography variant="heading2">
              {t('practiceCard.services')}
            </LuxTypography>
          }
        ></LuxModalHeader>
      }
      footer={
        <LuxModalFooter
          linkButtonVariant="ghost"
          linkButtonText={!isMobile ? t('generalCta.back') : ''}
          primaryButtonText={
            isMobile ? t('practiceCard.bookThis') : t('bookingTitle')
          }
          justifyContent={isMobile ? 'center' : 'flex-end'}
          primaryButtonSx={{ width: isMobile ? '100%' : 'auto' }}
          onLinkButtonClick={() => {
            onClose();
            setSelectedAppointmentId(undefined);
          }}
          onPrimaryButtonClick={() => {
            setAppTypeIdFromUrl(selectedAppointmentId);
            onClose();
            setTimeout(() => {
              history.push(`${Urls.APPOINTMENT_TYPE}`);
            }, 0);
          }}
          primaryButtonDisabled={!selectedAppointmentId}
        />
      }
      onClose={() => {
        onClose();
        setSelectedAppointmentId(undefined);
      }}
      size="large"
    >
      <Stack flexDirection="column" gap="1rem" paddingBottom={'1rem'}>
        {appointmentTypes?.map(app => {
          const isSelected = selectedAppointmentId === app.id;

          return (
            <AppointmentOption
              key={app.id}
              onClick={() => setSelectedAppointmentId(app.id)}
              selected={isSelected}
              selectedColor={
                theme.palette.LUX.obTokens?.bordersColorBrandPrimary
              }
              color={theme.palette.LUX.obTokens?.bordersColorNeutralSecondary}
              minHeight={!brandName}
            >
              <Stack
                flexDirection="row"
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                gap="2rem"
              >
                <Stack flexDirection="column" gap="0.5rem" width="80%">
                  <LuxSelectablePill
                    text={app.title}
                    selectable={false}
                    customColor={
                      theme.palette.LUX.obTokens.bgColorBaseSecondary
                    }
                    customBorderColor={
                      theme.palette.LUX.obTokens.bordersColorNeutralSecondary
                    }
                  />
                  <LuxTypography variant="textXs" textAlign="left">
                    {app.subtitle}
                  </LuxTypography>
                </Stack>
                <LuxRadioButton
                  standalone
                  noHelper
                  noLabel
                  options={[{ label: '', value: app.id }]}
                  direction="horizontal"
                  value={isSelected ? app.id : undefined}
                  onChange={() => setSelectedAppointmentId(app.id)}
                />
              </Stack>
            </AppointmentOption>
          );
        })}
      </Stack>
    </LuxModal>
  );
}
